import classNames from 'classnames';
import dynamic from 'next/dynamic';
import * as React from 'react';
import { UserContext } from '../../../contexts/UserContext';
import Merchant from '../../../domain/entities/Merchant';
import MerchantReservationButton from './MerchantReservationButton';

import css from './MerchantHeader.module.scss';

interface MerchantFavoriteButtonProps {
  className?: string;
  publicId: string;
  isLoggedIn: boolean;
}

const MerchantFavoriteButton = dynamic<MerchantFavoriteButtonProps>(
  import('./MerchantFavoriteButton').then(c => c.default),
  {
    loading: () => null,
    ssr: false,
  },
);

const bookingButtonIsActiveBy = (
  merchant: Merchant,
  bookingPageIsBookable?: boolean,
) => {
  // explore only merchant.
  if (
    merchant.setting.isExploreOnly &&
    merchant.setting.exploreOnlyMerchantReservationPageUrl !== ''
  ) {
    return true;
  }
  // bookable merchant on coubic.
  if (bookingPageIsBookable) {
    return true;
  }
  // others.
  return false;
};

export interface MerchantHeaderProps {
  merchant: Merchant;
  bookingPageIsBookable?: boolean;
}

interface Props extends MerchantHeaderProps {
  className?: string;
}

const MerchantHeader = ({
  className,
  merchant,
  bookingPageIsBookable,
}: Props) => {
  const classes = classNames(css.MerchantHeader, className);
  const userCtx = React.useContext(UserContext);
  const bookingButtonIsActive = bookingButtonIsActiveBy(
    merchant,
    bookingPageIsBookable,
  );
  return (
    <header className={classes}>
      <div
        className={css.MerchantHeader__Background}
        style={{
          backgroundImage: `url(${merchant.coverImage.url})`,
        }}
      />
      <div className={css.MerchantHeader__SummaryBg}>
        <div className={css.MerchantHeader__Summary}>
          <a
            className={css.MerchantHeader__SummaryLink}
            href={`/${merchant.publicId}`}
          >
            <div className={css.MerchantHeader__SummaryThumbnail}>
              <img
                className={css.MerchantHeader__ThumbnailImage}
                src={merchant.thumbnailImage.w120.url}
              />
            </div>
            <div className={css.MerchantHeader__SummaryText}>
              <h1 className={css.MerchantHeader__Name}>
                {merchant.displayName}
              </h1>
            </div>
          </a>
          <div className={css.MerchantHeader__SummaryRight}>
            {bookingButtonIsActive && (
              <div className={css.MerchantHeader__SummaryBook}>
                <MerchantReservationButton merchant={merchant} />
              </div>
            )}
            <div className={css.MerchantHeader__SummaryFavorite}>
              <MerchantFavoriteButton
                publicId={merchant.publicId}
                isLoggedIn={userCtx.auth.isLoggedIn}
              />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default MerchantHeader;
